export const GET_ALL = 'GET_ALL'
export const DETAIL = 'DETAIL'
export const INSERT = 'INSERT'
export const UPDATE = 'UPDATE'
export const UPDATE_INFO = 'UPDATE_INFO'
export const ACCESS_LOCAION = 'ACCESS_LOCAION'
export const REMOVE = 'REMOVE'